export default "11,Impediment\n12,Lav\n13,Middels\n14,Høy\n15,Særshøy\n17,Produktiv\n18,Høyogsærshøy\n98,Ikke relevant\n99,Ikke registrert\n"